// src/pages/debiteuern/components/InvoiceProjectTermList.js
// Dit is op Project niveau
import React from "react";
import InvoiceTermRow from "./InvoiceTermRow";
import { Card } from "react-bootstrap";

const InvoiceProjectTermList = ({ project, invoiceTerms, user }) => {
    return (
        <Card>
            <Card.Header>
                <Card.Title tag="h5" className="mb-0">
                    <h3>Verlopen facturenoverzicht</h3>
                </Card.Title>
            </Card.Header>
            <Card.Body>

                <div id="factuur_termijnen">
                    {invoiceTerms.length > 0 ? (
                        invoiceTerms.map(term => (
                            <InvoiceTermRow
                                key={term.projects_invoice_terms_id}
                                project={project}
                                term={term}
                                user={user}
                            />
                        ))
                    ) : (
                        <div className="justify-content-center align-self-center w-100 text-center">
                            Er zijn geen factuur termijnen gevonden.
                        </div>
                    )}
                </div>
            </Card.Body>
        </Card>
    );
};

export default InvoiceProjectTermList;
